import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import Sidebar from '../Sidebar'


class BlogItem extends Component {
	render() {
		return (
			<div>
				<Header
					bg="#08311d"
					image={require('./image.jpg')}
					title={"How Google Adwords Works"}
				/>
				<div className="entry-content">
					
					<div className="container">
						<h2 className="blog-details">
								<div className="author-circle david"></div>
								<div className="line"></div>
								<div className="title">
									Written by <strong>David</strong> on April 13 2018  //  Posted in <strong>Marketing, Advertising</strong>
								</div>
						</h2>
						
						<div className="row">
							<div className="col-lg-7">
								<div className="tagline">
								Let’s start with dividing our customers into two groups:
								</div>
								<ul className="with-icons">
									<li>Those looking for you now</li>
									<li>Those who will look for you in the future</li>
								</ul>
								<div className="tagline">Now Customers – Google Adwords Search</div>
								<p>If you don’t know who sells a product or want to do further research on items or suppliers, a common place to turn is Google Search. Here websites not only vie for position based on relevance, but Google business listings now also take up premium ‘above the fold’ real estate – seen without needing to scroll down. One way to get noticed on Google is to use paid advertising.</p>

								<img src={require('./image-1.png')} alt="Google Adwords Example 1" className="align-left" align="left" />

								<p>Google Adwords Search campaigns allow you to target specific searches and have a rich text advert appear above normal search results. These adverts work on a ‘pay per click’ format, which means appearances of the advert are free while clicking on the advert – and moving on to the advertiser’s website – causes a fee to be charged.  How much is this fee?  This is mainly determined by demand for advertising on the search term in question. Businesses bid on a search term in competition with other businesses, with the winning bids getting higher placements on search results. There is space at the top of Google search results for 3 paid adverts, so these three positions are the most popular to bid for.</p>

								<div className="tagline">How Google Charges You</div>

								<p>It gets a little more complicated than the bid amount. The bid that wins your advert’s position is not necessarily the fee Google charges you. Google wants to encourage the best businesses to advertise online, so the final cost can be reduced by a number of different factors.</p>
								
								<ul className="with-icons">
									<li>The relevance and quality of the landing website</li>
									<li>The relevance and quality of the adverts being used</li>
									<li>The popularity of the search terms being targeted</li>
								</ul>

								<p>Therefore before a business enters into Adwords Search advertising it is important to invest in a good quality website and advertising management.  This can have a huge impact on the cost effectiveness of your advertising – in some cases you could end up paying only 1/10 of what competitors are being charged.  Back to the question, what is the fee for a click on an advert? You can expect to pay between $1 – $10 per click.</p>

								<div className="tagline">
									Importance of Management
								</div>

								<p>Management not only means making adverts, it should also mean ongoing monitoring of the campaigns to maximise performance with regular updates and meetings to make sure the advertising is producing results. Management should also involve setting up data connections between the adverting and your website to find out where your enquiries or sales come from and to employ Google’s AI bidding optimisation.</p>

								<p><strong>Future Customers – Google Adwords Display and Video Advertising</strong></p>

								<p>This sort of advertising is important because it is an effective way of establishing your brand in the community.  It is best understood as the digital equivalent of newspaper and television advertising.</p>

								<div className="tagline">Google Display Banner Advertising</div>

								<img src={require('./image-2.png')} alt="Google Adwords Example 2" className="align-left" align="left" />

								<p>Google Display advertising places banner adverts on popular websites which show advertising on the top, bottom or sides of their pages. There are hundreds of websites that show Google Display advertising, including newspaper, second hand and gossip websites.  With the use of an image and tagline, these adverts are a great way to get your message across or have themed campaign to do with special occasions or seasons.  Adverts can be generated automatically using text and images provided, or they can be custom designed to provide the greatest impact. If the reader is interested in the advert, then clicking on an advert leads them to the business’s website.</p>

								<div className="tagline">Google Adwords Video Advertising </div>

								<img src={require('./image-3.png')} alt="Google Adwords Example 3" className="align-left" align="left" />

								<p>When you watch a video online there is a chance that an advert may appear before or during the video. These short video advertisements come from the Google Adwords Video platform. The viewer has to watch 5 seconds of the advert before being able to skip, so video adverts provide an opportunity to promote a rich branded message to your market. If the viewer is interested and continues to watch for 30 seconds (or less if the advert length is shorter), Google charges a fee called pay per view.  Visiting the website is easy through the website address shown.</p>

								<div className="tagline">How Targeting Works</div>

								<p>Both Google Display and Video advertising differ to Search as they do not appear on Google searches but rather on websites either showing advertising or playing videos which are stored on YouTube.  Targeting for both Display and Video campaigns can be done in a number of other ways:</p>
								

								<ul className="with-icons">
									<li>
										Location and demographic, eg ‘All women aged 25-34 in Bunbury’ or ‘All parents in the top 40% income bracket in the south west’
									</li>
									<li>Viewer interests, eg ‘All people who like travel in WA’</li>
									<li>Website content, eg ‘Show on all websites about technology in Australia’</li>
								</ul>

								<p>Refining a campaign can involve a combination, eg ‘Show on all websites about technology in Australia’ may later show women are more receptive than men to the advertising, so additionally, ‘Show only to women’ is included.</p>

								<div className="tagline">How Google Charges You</div>

								<p>Google Adwords Display can be charged per click or per thousand appearance.  Google Video advertisements work on pay per view.  When an advert position becomes available then this opens a bidding war among advertisers. Better positioned adverts attract higher bids and are therefore more expensive to appear on. Typically though, a cost for a click on a Display banner advert is less than $0.50 (per 100 – 300 views) while a 30 second view on a Video campaigns is less than $0.10 (per 500 – 1000 views).</p>

								<div className="tagline">Importance of Management</div>

								<p>The strength in Display and Video advertising is the performance data available, so campaigns must be set up in a way to maximise testing opportunities. Combinations of images or video with different themed text set up matrices of adverts that can be tested against different demographics in different areas.  This information provides insight not only in the cost effectiveness of campaigns but also how the market responds to the business’s brand.  There have been many occasions where demographic data has provided insights into a market that has spurned discussions about re-branding.</p>

								<p><strong>Our Google Adwords Management Services</strong></p>

								<p>Moshi Moshi Marketing is a certified Google Partner and has been awarded specialisations in Search, Mobile and Display advertising. Our performance is regularly assessed ensuring the highest quality management services for your Adwords advertising account.</p>

								<p>We offer a range of management plans depending on the complexity and budget of your campaigns. Display and Video management starts at $150/month and Search management starts at $300/month (includes Display and Video).  This is in addition to the daily budgets allocated to the Adwords campaigns which are paid directly to Google. All plans include monthly performance reports with monthly or quarterly meetings to carefully monitor results and refine campaigns.</p>

								<p>Our graphic design and video production services are also available to create professional, targeted adverts.</p>




							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-4">
								<Sidebar />
							</div>
						</div>
					</div>
				</div>

			</div>
		);
	}
}

export default BlogItem;


// WEBPACK FOOTER //
// ./src/Pages/Blog/HowGoogleAdwordsWorks/index.js